<div
  ctExtractionOcrFormInput
  [activeField]="currentActiveField()"
  [currentDocument]="currentDocument()"
  class="flex h-full min-h-0 flex-col gap-4">
  @for (section of extractionPage()?.sections; track $index) {
    @if (isFieldGroupModel(section)) {
      <ct-extraction-field-group-extraction-view
        [isConsolidation]="false"
        [document]="currentDocument()"
        [fieldGroupModel]="section"
        [currentFieldModel]="currentActiveFieldModel()"
        [focusInputs]="false"
        (currentExtractionFieldChange)="
          currentActiveSection.set(section); currentActiveField.set($event)
        "
        [isActiveSection]="currentActiveSection() === section"
        (statusChange)="onSectionStatusChange(section, $event)"
        (valueChange)="saveFieldGroupValues($event)"
        (formFieldMapChanged)="mergeFormFieldMap($event)"
        [prefillResults]="initialFieldDataBySectionKey()"
        class="min-h-fit" />
    } @else if (isTableModel(section)) {
      @if (initialTableRowsByKeyResource.hasValue()) {
        <ct-extraction-table-extraction-view
          (continue)="focusNextSection.emit()"
          [formArrayCacheKey]="`${currentDocument().id}-${section.key}`"
          [capturingConfig]="{
            document: currentDocument(),
            tableModel: section,
          }"
          [isActiveSection]="currentActiveSection() === section"
          [currentFieldModel]="currentActiveFieldModel()"
          [hasMultipleTableSections]="hasMultipleTableSections()"
          (currentExtractionFieldChange)="
            currentActiveSection.set(section); currentActiveField.set($event)
          "
          (statusChange)="onSectionStatusChange(section, $event)"
          (tableValueChange)="saveTableValues(section.key, $event)"
          (fieldValueChanged)="saveFieldGroupValues($event)"
          [initialFieldData]="initialFieldDataBySectionKey().fields"
          [initialRows]="initialTableRowsByKeyResource.value()?.[section.key] ?? []"
          class="max-h-full min-h-0 shrink-0" />
      } @else {
        <span>loading rows...</span>
      }
    }
  }
</div>

<ct-extraction-discard-table-dialog
  #discardTableDialog
  (acceptedDialog)="discardAndGoToPrevView()" />
